export class GrupoProcesso {
    id = 0;
    descricao = '';
}